<template>
  <!--创建合同-->
  <div>
    <div class="info-all" v-show="!dialogVisible">
      <!--左侧-->
      <el-aside
        width="2.80rem"
        class="aside-left"
        :style="{ height: boxHeight }"
      >
        <p class="page-total">
          <span class="tit">签署文件列表</span>
          <span>共{{ fileList.length }}个</span>
        </p>
        <div class="page-con">
          <template v-for="(file, i) in fileList">
            <div
              :key="i"
              @click="chooseFile(file, i)"
              :class="checkAct === i ? 'active' : ''"
              class="list"
            >
              <div class="bx">
                <img :src="fileIcon(file)" />
              </div>
              <p class="title" :title="file.fileName">{{ file.fileName }}</p>
            </div>
          </template>
        </div>
      </el-aside>
      <transition name="el-fade-in">
        <div
          class="aside"
          :style="{ height: boxHeight }"
          v-show="drawerShow"
        ></div>
      </transition>
      <transition name="my">
        <div
          class="aside-content"
          :style="{ height: boxHeight }"
          v-show="drawerShow"
        >
          <div class="aside-top">
            仅供参与方查阅，不用于签署（共
            {{ this.enclosureFilesList.length }} 份）
            <span class="el-icon-error" @click="drawerShow = false"></span>
          </div>
          <div class="aside-box" :style="{ height: windowHeight - 120 + 'px' }">
            <div class="enclosure-box">
              <div
                class="enclosure-item"
                v-for="(item, index) in enclosureFilesList"
                :key="index"
              >
                <!--预览-->
                <div class="li-preview">
                  <!--图片和video预览-->
                  <span
                    class="el-icon-view"
                    title="预览"
                    v-if="isImg(item) || isVideo(item)"
                    @click="previewVideOrImg(item)"
                  ></span>
                  <!-- 文档预览-->
                  <span
                    class="el-icon-view"
                    title="预览"
                    v-if="isDoc(item)"
                    @click="previewDoc(item)"
                  ></span>
                  <a :href="downloadAttatchFile(item)" target="_blank">
                    <span class="el-icon-download" title="下载"></span>
                  </a>
                </div>
                <div class="li-con">
                  <div class="t-do">{{ getEnclosureSuffix(item) }}</div>
                  <h1 :title="item.fileName">{{ item.fileName }}</h1>
                </div>
              </div>
            </div>
            <no-data
              v-if="enclosureFilesList.length === 0"
              text="暂无数据"
              slot="empty"
            />
          </div>
        </div>
      </transition>
      <div class="aside-tab" :class="drawerShow ? 'open' : 'close'">
        <div class="tab" @click="openTab" :class="drawerShow ? 'active' : ''">
          <i class="el-icon-circle-plus"></i>
          <span class="word">附属材料&nbsp;&nbsp;</span>
          <i
            :class="drawerShow ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
          ></i>
        </div>
      </div>
      <div
        v-if="fileImgName"
        class="file-img-btn"
        @click="fileImgShow = !fileImgShow"
      >
        {{ fileImgName || "" }}
        <strong
          class="file-arrow"
          :class="fileImgShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
        ></strong>
      </div>
      <!--合同显示详情-->
      <el-main class="main-content" :style="{ height: boxHeight }">
        <date-office
          v-if="showofficeEditor && beWord(fileList[checkAct].fileName)"
          :editor="editor.editorConfig"
        ></date-office>
        <template v-else>
          <contract-view
            ref="contractView"
            :contract-info.sync="currentInfo"
            :chapter-list.sync="chapteJson"
            :items="contractInfoTemporary.items"
            :page="currentInfo.page"
            :scaleValue.sync="scaleValue"
            :targetId="contractInfoTemporary.targetId"
            :show-chapter="true"
            :isDetail="true"
            @pre-page="getContractDetailByNum($event)"
            @next-page="getContractDetailByNum($event)"
            @changeSmallMap="changeSmallMap"
            @toCurrentPage="toCurrentPage"
          />
          <div class="contract-bottom">
            <template
              v-if="
                contractInfoTemporary &&
                contractInfoTemporary.items &&
                contractInfoTemporary.items > 1
              "
            >
              <el-tooltip effect="light" placement="left-start">
                <div slot="content">回到首页</div>
                <span class="jumpFirst" @click="goPageAndFixed(1)"
                  ><img src="../../../../assets/images/btn-down.png"
                /></span>
              </el-tooltip>
              <el-tooltip effect="light" placement="left-end">
                <div slot="content">回到尾页</div>
                <span
                  class="jumpLast"
                  @click="goPageAndFixed(contractInfoTemporary.items)"
                  ><img src="../../../../assets/images/btn-down.png"
                /></span>
              </el-tooltip>
            </template>
          </div>
        </template>
      </el-main>
      <!--右侧-->
      <el-aside
        width="2.80rem"
        class="aside-right"
        :style="{ height: boxHeight }"
      >
        <div class="right-bottom">
          <el-button @click="backStep" size="mini" type="primary" v-if="!isView"
            >保存</el-button
          >
          <span v-else class="read-only">当前合同已完成编辑，目前只读状态</span>
        </div>
      </el-aside>
    </div>
    <!-- 进入页面蒙层 -->
    <el-dialog
      title="请输入验证码"
      center
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        :inline="true"
        :model="verifyForm"
        size="small"
        class="demo-form-inline"
        style="margin: 0 auto; margin-top: 20px"
        @submit.native.prevent="verifyCheck"
      >
        <el-form-item label="验证码">
          <el-input
            v-model="verifyForm.verifyCode"
            placeholder="请输入验证码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="verifyCheck">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// API
import {
  ApiMethods,
  getFindFileDownload,
  convertDetailToShow,
  tempConvertToContract,
} from "../../../../assets/js/http-serve/http-methods";
// tool
// components
import ContractView from "../../../../components/contract-view/index";
import cooperPup from "./cooperPup.vue";
import dateOffice from "../../../../components/onlyOffice/index.vue";

export default {
  data () {
    return {
      isView: false,
      dialogVisible: true,
      cooperateInfo: {
        draftCoEditingSec: ''
      },
      upFiles: null, // 发起时上传的文件和附件
      verifyForm: { verifyCode: '' },
      cooperVisi: false, // 邀请审阅弹窗
      textcontent:
        "将发送协同编辑链接给他人，收到链接的人可编辑合同内容，编辑结果实时查看（仅doc、docx格式文件可编辑）",
      showofficeEditor: false,
      editor: {},
      labelWidth: "150px",
      chapteJson: [],
      boxHeight: "1170px",
      windowHeight: 798,
      leftCSideHeight: 0,
      loading: null,
      // 当前页信息
      currentInfo: { page: 1, url: "" },
      // 临时展示合同信息
      contractInfoTemporary: {},
      // 小地图 拖动相对位移
      deviationSmallMap: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        clientWidth: 0,
        clientHeight: 0
      },
      // 合同缩放比例
      scaleValue: 100,
      // 文件上传列表
      fileList: [],
      // copy 文件上传列表 （含有模板发起步骤，点击上一步做数据回显)
      copyTemp: [],
      // 附件
      enclosureFilesList: [],
      // pdf 预览
      visibleShowEnclosureDoc: false,
      //其他 文件预览
      visibleShowEnclosure: false,
      enclosurePreviewNumItem: {}, // 当前预览项
      checkAct: -1, // 当前显示合同选中文件
      isRefresh: true, // 预览附件时，强制刷新
      drawerShow: false, //侧边展示
      fileImgName: "",
      fileImgShow: true,
      PDFImg: require("../../../../static/images/advancedVersion/pdf.png"),
      JPGImg: require("../../../../static/images/advancedVersion/JPG.png"),
      XLSImg: require("../../../../static/images/advancedVersion/xlsx.png"),
      DOCImg: require("../../../../static/images/advancedVersion/word.png"),
      WPSImg: require("../../../../static/images/advancedVersion/WPS.png"),
      TPLImg: require("../../../../static/images/advancedVersion/tpl.png")
    };
  },
  mounted () {
    this.boxHeight = document.body.clientHeight - 60 + "px";
    this.leftCSideHeight =
      document.body.getBoundingClientRect().height - 150 + "px";
    this.windowHeight = document.body.getBoundingClientRect().height;
  },
  methods: {
    // * 协同编辑【1406】
    // 获取文件
    getUpFiles (checkAct) {
      const { checkCode, draftIdSec, mobile, sign, ts } = this.$route.query;
      const params = { checkCode, draftIdSec, sign, ts, verifyCode: `${mobile}_${this.verifyForm.verifyCode}` }
      ApiMethods.cooperateWithSign.draftInfo(params).then(res => {
        if (!res.success) return this.$message.error(res.description);
        const files = res.data.files;
        const upFiles = [];
        files.forEach(file => {
          if (file.fileType === 1) {
            if (file.sourceFile) {
              let target = file.sourceFile.targetId;
              let first = target.lastIndexOf("."); //取到文件名开始到最后一个点的长度
              let namelength = target.length; //取到文件名长度
              let filesuffix = target.substring(first, namelength); //截取获得后缀名
              file.fileName = file.fileName.split(".")[0] + filesuffix;
            }
            upFiles.push(file)
          }
          if (file.fileType === 2) {
            this.enclosureFilesList.push(file)
          }
        });
        this.fileList = upFiles
        const index = checkAct > -1 ? checkAct : 0;
        this.chooseFile(this.fileList[index], index)
      });
    },
    // 校验验证码
    verifyCheck () {
      const { checkCode, draftIdSec, mobile, sign, ts } = this.$route.query;
      const params = { checkCode, draftIdSec, sign, ts, verifyCode: `${mobile}_${this.verifyForm.verifyCode}` }
      ApiMethods.cooperateWithSign.draftVerify(params).then(res => {
        if (!res.success) return this.$message.error(res.description)
        this.dialogVisible = !this.dialogVisible
        this.getUpFiles();
      })
    },
    // 调用loading并获取原文件
    saveLoading (sourceFile, index) {
      this.loadingStart();
      setTimeout(() => {
        // this.loadingClose();
        this.editedFile(sourceFile, index);
      }, 5 * 1000);
    },
    // 获取office编辑后的文件
    editedFile (sourceFile, index) {
      this.getUpFiles(this.checkAct)
    },
    // onlyoffice 编辑
    InOnlyOffice (file, index) {
      const sourFile = file.sourceFile;
      this.chapteJson = [];
      this.loadingStart();
      const { checkCode, draftIdSec, mobile, sign, ts } = this.$route.query;
      const params = { checkCode, draftIdSec, sign, ts, verifyCode: `${mobile}_${this.verifyForm.verifyCode}`, fileKey: sourFile.fileKey }
      ApiMethods.cooperateWithSign
        .draftSetup(params)
        .then(res => {
          if (!res.success) return this.$message.error(res.description);
          const { data } = res,
            { sourceFile } = file;
          this.isView = data.editorConfig.mode && data.editorConfig.mode === 'view' ? true : false
          this.editor = {
            editorConfig: Object.assign(
              { width: "100%", height: this.boxHeight },
              data
            ),
            sourceFile,
            fileIndex: index
          };
          this.showofficeEditor = true;
        })
        .finally(() => {
          this.loadingClose();
        });
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    toCurrentPage (val) {
      let dom = document.querySelectorAll(".list-pages .listDetail")[val - 1];
      if (dom) {
        document.querySelectorAll(".list-pages")[0].scrollTop = dom.offsetTop;
      }
    },
    //  按页数获取合同，在左侧目录定位当前页，中间合同滚动到顶部从头展示
    goPageAndFixed (page) {
      this.getContractDetailByNum(page);
      this.toCurrentPage(page);
      document.querySelectorAll(".contract-view")[0].scrollTop = 0;
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    // 按页数获取合同
    getContractDetailByNum (num) {
      if (this.contractList[num]) {
        return (this.currentInfo = this.contractList[num]);
      }
      this.currentInfo = {
        page: num,
        url: convertDetailToShow({
          docHash: this.contractInfoTemporary.docHash,
          ts: this.contractInfoTemporary.ts,
          sign: this.contractInfoTemporary.sign,
          items: this.contractInfoTemporary.items,
          targetId: this.contractInfoTemporary.targetId,
          fileType: 3,
          fix: "png",
          num: num - 1
        })
      };
      if (!this.contractList[num]) {
        this.contractList[num] = this.currentInfo;
      }
    },
    changeSmallMap (val) {
      this.deviationSmallMap = val;
    },
    // 存储文件的合同文件转换，非上传的临时文件转换
    convertContractToInfo (param) {
      const _this = this;
      _this.loadingStart("正在加载合同信息");
      tempConvertToContract(param)
        .then(({ data }) => {
          _this.loadingClose();
          _this.contractInfoTemporary = {
            docHash: data.docHash,
            ts: param.ts,
            sign: param.sign,
            items: parseInt(data.items),
            targetId: param.targetId
          };
          _this.fileImgName = param.fileName;
          _this.getContractDetailByNum(1);
        })
        .catch(err => {
          _this.loadingClose();
          console.error("合同文件转换 " + JSON.stringify(err));
        }).finally(() => { _this.loadingClose() });
    },
    // 判断文件是否是doc类型
    beWord (fileName) {
      let filesuffix = "";
      if (fileName) {
        let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        let namelength = fileName.length; //取到文件名长度
        filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      }
      return filesuffix === "doc" || filesuffix === "docx";
    },
    backStep () {
      const _this = this, currentFile = this.fileList[this.checkAct];
      console.log('currentFile', currentFile, this.checkAct);
      if (!_this.beWord(currentFile.fileName)) return
      _this.loadingStart()
      const { checkCode, draftIdSec, mobile, sign, ts } = _this.$route.query, { sourceFile } = currentFile;
      const params = { checkCode, draftIdSec, sign, ts, verifyCode: `${mobile}_${_this.verifyForm.verifyCode}`, fileKey: sourceFile.fileKey }
      ApiMethods.cooperateWithSign.endCoopre(params).then(res => {
        if (!res.success) return _this.$message.error(res.description)
        setTimeout(() => {
          _this.$message.success('保存成功')
          _this.loadingClose()
        }, 1000);
      })
    },
    fileIcon (file) {
      let filesuffix = "tpl",
        fileName = file.fileName;
      if (fileName) {
        let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        let namelength = fileName.length; //取到文件名长度
        filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      }
      switch (filesuffix) {
        case "pdf":
          return this.PDFImg;
        case "jpg":
          return this.JPGImg;
        case "doc":
        case "docx":
          return this.DOCImg;
        case "xls":
        case "xlsx":
          return this.XLSImg;
        case "tpl":
          return this.TPLImg;
        default:
          // wps
          return this.WPSImg;
      }
    },
    // 附属材料打开与关闭
    openTab () {
      this.drawerShow = !this.drawerShow;
      this.fileImgShow = this.drawerShow ? false : true;
    },
    // 903需求新增
    // 获取附件后缀
    getEnclosureSuffix (item) {
      if (item && item.fileOperVO && item.fileName) {
        let arr = item.fileName.split(".");
        return arr[arr.length - 1];
      }
      return "";
    },
    // 附件下载
    downloadAttatchFile (param) {
      if (!param || param === "null" || param === "false")
        return "javascript:void(0)";
      if (param.fileName === "blob") {
        param.fileName = "attachment.png";
        param.fix = ".png";
      }
      let VO = param.fileOperVO;
      const files = {
        fileName: param.fileName,
        fileSize: VO.fileSize,
        fileType: VO.fileType,
        sign: VO.sign,
        targetId: VO.targetId,
        ts: VO.ts
      };
      return getFindFileDownload(files);
    },
    // 附件是否是图片
    isImg (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      let arr = ["PNG", "GIF", "JPG", "JPEG"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否是视频
    isVideo (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['MP4','RMVB','MKV','AVI']
      let arr = ["MP4", "WEBM", "OGG"];
      // let arr = ['MP4']
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否文档
    isDoc (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PDF"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 预览图片或者视频
    previewVideOrImg (item) {
      let files = {
        id: item.fileOperVO.targetId,
        file: {
          fileType: item.fileOperVO.fileType,
          sign: item.fileOperVO.sign,
          targetId: item.fileOperVO.targetId,
          ts: item.fileOperVO.ts,
          fileName: item.fileName
        }
      };
      this.enclosurePreviewNumItem = files;
      this.visibleShowEnclosure = true;
      // 刷新预览弹窗，更新
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    // 执行预览图片视频关闭后参数回传
    onSetViewFilesToImgDialogData (data) {
      this.visibleShowEnclosure = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 预览文档
    previewDoc (item) {
      let files = {
        id: item.fileOperVO.targetId,
        file: {
          fileType: item.fileOperVO.fileType,
          sign: item.fileOperVO.sign,
          targetId: item.fileOperVO.targetId,
          ts: item.fileOperVO.ts,
          fileName: item.fileName
        }
      };
      this.enclosurePreviewNumItem = files;
      this.visibleShowEnclosureDoc = true;
    },
    // 切换文件展示合同
    chooseFile (file, i) {
      if (!this.beWord(file.fileName)) return this.coverFile(file, i)
      this.loadingStart();
      setTimeout(() => {
        this.loadingClose();
      }, 1000);
      this.InOnlyOffice(file, i)
      const { fileOperVO: VO } = file;
      const fileVO = VO ? VO : file;
      if (this.checkAct === i) return;
      this.checkAct = i;
    },
    // 原逻辑查看文件
    coverFile (file, i) {
      const { fileOperVO: VO } = file;
      const fileVO = VO ? VO : file;
      if (this.checkAct === i) return;
      this.contractList = {};
      this.convertContractToInfo(fileVO);
      this.checkAct = i;
    },
    // 获取文件后缀
    fileSuffix (fileName) {
      let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let namelength = fileName.length; //取到文件名长度
      let filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      return filesuffix;
    },

    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
  },
  components: {
    ContractView,
    cooperPup,
    dateOffice
  },
  head: { title: "文件发起协同" },
  layout: "fullpage"
};
</script>
<style lang="less">
.el-dialog {
  margin-top: 20% !important;
}
.el-dialog--center .el-dialog__body {
  text-align: center;
}
.el-dialog__body {
  padding-top: 0;
}
</style>
<style scoped>
.el-button:hover {
  color: #ffffff !important;
}
</style>
<style lang="less" scoped>
.contract-bottom {
  position: absolute;
  bottom: 110px;
  right: 0;
  width: 50px;
  height: auto;
  pointer-events: none;
  z-index: 8;
}
.info-all {
  min-height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-width: 0;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: #f5f5f5;
}
.file-img-btn {
  position: absolute;
  z-index: 102;
  top: 60px;
  left: 2.8rem;
  width: 1.8rem;
  height: 30px;
  background-color: #eb1b1b;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 20px 0 10px;
  color: #ffffff;
  cursor: pointer;
  strong.file-arrow {
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    top: 8px;
    right: 4px;
  }
}

.tpl-icon {
  position: absolute;
  color: #fff;
  background-color: #ec1c1c;
  padding: 1px 3px;
  border-radius: 4px;
  font-size: 12px;
}
.tpl-posi {
  top: 0;
  left: 0;
}

.aside {
  position: absolute;
  top: 0px;
  width: calc(100% - 2.8rem);
  z-index: 100;
  left: 2.8rem;
  background-color: rgba(0, 0, 0, 0.6);
}

.aside-tab {
  width: 32px;
  height: auto;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 102;

  .tab {
    width: 32px;
    height: 135px;
    writing-mode: vertical-lr;
    font-size: 12px;
    color: #a1a1a1;
    background-color: #fff;
    border-radius: 0 10px 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);

    .word {
      margin: 5px 0;
    }
  }

  .tab.active {
    color: #eb090a;
  }
}

.aside-tab.open {
  left: calc(800px + 2.8rem);
}

.aside-tab.close {
  left: 2.45rem;
  z-index: 103;
}

.aside-content {
  position: absolute;
  top: 0px;
  left: 2.8rem;
  width: 800px;
  height: 100%;
  box-sizing: border-box;
  background-color: #eeeeee;
  z-index: 103;
  overflow: hidden;

  .aside-top {
    width: 100%;
    height: 60px;
    background-color: #f8f8f8;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    align-items: center;
    font-size: 12px;
    /*position: absolute;*/
    /*top: 0;*/
    /*left: 0;*/

    .el-icon-error {
      font-size: 20px;
      cursor: pointer;
      color: #646464;
    }
  }

  .aside-box {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    position: absolute;
    overflow-y: auto;
    height: auto;

    .enclosure-box {
      display: flex;
      flex-wrap: wrap;

      .enclosure-item {
        width: 110px;
        height: 110px;
        margin: 10px;
        position: relative;

        &:hover {
          .li-preview {
            width: 100%;
            height: 100%;
            opacity: 1;
          }
        }

        .li-preview {
          cursor: default;
          font-weight: bold;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.7);
          opacity: 0;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all ease-in 0.2s;
          z-index: 3;
          color: #ffffff;
          font-size: 18px;

          span {
            color: #ffffff;
            margin-top: -20px;
            display: inline-block;
            cursor: pointer;
            font-weight: bold;
            margin-right: 20px;

            &:last-child {
              margin-right: 0;
            }
          }

          a {
            margin-top: -20px;
            display: inline-block;
          }

          img {
            width: 100%;
            height: auto;
          }
        }

        .li-con {
          box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);
          line-height: 90px;
          text-align: center;
          /*position: relative;*/
          width: 100%;
          height: 100%;
          overflow: hidden;

          img {
            max-width: 100%;
            max-height: 100%;
          }

          h1 {
            cursor: default;
            z-index: 4;
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            background: rgba(0, 0, 0, 1);
            height: 20px;
            text-align: center;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: rgba(255, 255, 255, 1);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            opacity: 0.7;
            box-sizing: border-box;
            padding: 0 5px;
          }

          .t-do {
            line-height: initial;
            padding-top: 30px;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            color: #646464;
            font-weight: bold;
            font-size: 20px;
            font-family: PingFang SC;
            text-align: center;
            background: url("../../../../assets/images/bg-repeat.png") repeat;
            background-size: contain;
          }
        }
      }
    }
  }
}

.main-content {
  position: relative;
  display: table-cell;
  box-sizing: border-box;
  vertical-align: top;
  padding: 0;
  /*background: #ffffff;*/
  overflow: hidden;
}

@mg: 0.2rem; // 左右side给中间合同流的间距
.aside-right {
  box-sizing: border-box;
  // padding: 20px 20px 0 20px;
  background-color: #ffffff;
  overflow: hidden;
  position: relative;
  box-shadow: -0.02rem 0px 0.16rem rgba(0, 0, 0, 0.12);
  /*z-index:3;*/
  margin-left: @mg;

  .page-total {
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    box-sizing: border-box;
    border-bottom: 1px solid #f2f2f2;
    width: 100%;
    display: flex;
    background-color: #ffffff;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 60px;
    z-index: 2;
  }

  .right-bottom {
    background-color: #ffffff;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    /*z-index: 2000;*/
    padding: 0.2rem 0.27rem;
    box-shadow: 0px -0.03rem 0.12rem rgba(0, 0, 0, 0.16);

    button {
      font-size: 12px;
      width: 100%;
      margin: 5px 0;
    }
  }

  .btn {
    width: 100%;
    margin: 0 0 0.14rem 0;
  }

  button {
    /*height: .40rem;*/
    /*line-height: .40rem;*/
    font-size: 0.14rem;
  }
}

.aside-left {
  box-sizing: border-box;
  background-color: #ffffff;
  margin-right: @mg;
  overflow-y: auto;
  position: relative;
  z-index: 103;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);

  .cred {
    color: #ec1c1c;
  }

  .list {
    position: relative;
    cursor: pointer;
    width: 168px;
    height: 155px;
    margin: 0.2rem auto;
    border-radius: 4px;
    overflow: hidden;
    border: 0.02rem solid #e5e5e5;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);
    i.icon {
      position: absolute;
      top: 0;
      right: 0;
      width: 0.4rem;
      height: 0.4rem;
      background-size: cover;
      cursor: pointer;
      z-index: 1;
    }
    .bx {
      width: 100%;
      height: 100px;
      text-align: center;
      line-height: 110px;
      position: relative;

      img {
        height: 48px;
        width: auto;
      }
    }

    p.title {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      padding: 0 10px;
      text-align: center;
      height: 45px;
      width: 100%;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #290202;
      line-height: 23px;
    }
  }

  .list.active {
    border-color: #ec1c1c;
  }

  .page-total {
    color: #646464;
    font-size: 85%;
    border-bottom: 1px solid #f2f2f2;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 60px;
    box-sizing: border-box;

    .tit {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .page-con {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0.1rem;
    top: 60px;
  }
}
.read-only {
  font-size: 16px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
}
</style>



// WEBPACK FOOTER //
// pages/initiation/components/cooperateWith/reviewer.vue